import { render, staticRenderFns } from "./reportsOfProduct.vue?vue&type=template&id=a1d5525e&"
import script from "./reportsOfProduct.vue?vue&type=script&lang=js&"
export * from "./reportsOfProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports